// Arena: the broadcast-grade website template (NBA.com-style structure, no
// pro-league marks). Eager and tiny; the template itself loads lazily.
// Design: designs/arena/DIRECTION.md (founder-approved 2026-10-08).

import { defineManifest } from '../../core/template/defineTemplate'
import { SITE_TEMPLATE_CONTRACT } from '../../core/template/types'
import { ARENA_OPTIONS } from './options'
import thumbnail from './thumbnail.webp'

export const ARENA_FONTS = [
  'https://fonts.googleapis.com/css2?family=Archivo:ital,wdth,wght@0,62..125,100..900;1,62..125,100..900&display=swap',
]

export default defineManifest({
  id: 'arena',
  name: 'Arena',
  description: (m) => m.siteTemplates.arena.description,
  bestFor: (m) => m.siteTemplates.arena.bestFor,
  status: 'stable',
  contract: SITE_TEMPLATE_CONTRACT,
  // The fictional Ironbridge league (no real tenant in picker thumbnails).
  thumbnail,
  options: ARENA_OPTIONS,
  fonts: ARENA_FONTS,
  capabilities: { homeColumns: true, homeMobileOrder: true },
  load: () => import('./template'),
})
